import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { AUDIENCE_POINTS, DISCIPLINES } from './salesData';
import { COACHES_IMAGE_URL } from '../utils/headMeta';
export function AudienceSection() {
  return <section id="para-quien" className="bg-ivory py-12 sm:py-16" data-id="element-30" data-mp="s1e2trjh9oaq">
      <div className="mx-auto max-w-5xl px-5" data-id="element-31" data-mp="wzxnzpq8yw21">
        <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-12" data-id="element-32" data-mp="wxl8dj7yoxs5">
          <div data-id="element-33" data-mp="3viwc83ewf3d9">
            <h2 className="font-display text-[1.55rem] font-bold uppercase leading-tight text-charcoal sm:text-[2.1rem]" data-id="element-34" data-mp="3vf8gcxlze4vd">
              Coach Digital PRO es <span className="text-gold-deep" data-id="element-35" data-mp="99lcy5zpgj78">para vos si…</span>
            </h2>

            <ul className="mt-6 space-y-2.5" data-id="element-36" data-mp="e0jsv4gs7f9y">
              {AUDIENCE_POINTS.map((point, i) => <motion.li key={point} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-40px'
            }} transition={{
              duration: 0.3,
              delay: i * 0.04
            }} className="flex items-start gap-2.5" data-id="element-37" data-mp="3cr3fpz0mf00s" data-mpi={i}>
                  <span className="mt-[2px] flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-38" data-mp="zchmscua6lmz">
                    <CheckIcon className="h-2.5 w-2.5 text-ivory" aria-hidden data-id="element-39" data-mp="uimy0uztjgh1" />
                  </span>
                  <span className="font-sans text-[0.86rem] leading-relaxed text-charcoal/75" data-id="element-40" data-mp="lkb8yxeloqqp">
                    {point}
                  </span>
                </motion.li>)}
            </ul>

            <ul className="mt-6 flex flex-wrap gap-1.5" aria-label="Especialidades" data-id="element-41" data-mp="bm54q95bn8io">
              {DISCIPLINES.map(d => <li key={d} className="rounded-full border border-stone bg-sand px-2.5 py-1 font-sans text-[0.68rem] font-medium text-charcoal/70" data-id="element-42" data-mp="7lbh7gvsjvqb">
                  {d}
                </li>)}
            </ul>
          </div>

          <img src={COACHES_IMAGE_URL} alt="Coaches grabando contenido con el celular y trabajando en sesiones por videollamada" width={1200} height={800} loading="lazy" decoding="async" sizes="(max-width: 1024px) 90vw, 480px" style={{
          aspectRatio: '3 / 2'
        }} className="h-auto w-full rounded-2xl border border-stone object-cover shadow-[0_28px_60px_-40px_rgba(10,26,51,0.5)]" data-id="element-43" data-mp="3vh1pasp3chc2" />
        </div>
      </div>
    </section>;
}